// @flow

import { REQUIRED_OPTIONS } from '../data/constants'

export function checkIsRequired (name: string, endOfWorkFlowSessions: string[]): boolean {
  return endOfWorkFlowSessions.includes(name) || REQUIRED_OPTIONS.includes(name)
}
